import { serialize } from 'object-to-formdata'
import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  updateExtensionRule({
    courseId,
    resourceType,
    nominationExtensionRulesAttributes = [],
    itemExtensionRulesAttributes = [],
  }) {
    const formData = serialize(snakecaseKeys({
      resourceType,
      extensionRule: {
        nominationExtensionRulesAttributes,
        itemExtensionRulesAttributes,
      },
    }, { exclude: ['_destroy'] }))

    return axiosIns.put(`/waiter/courses/${courseId}/extension_rules/`, formData)
  },
}
